


















































































































































import {
  Component,
  Prop,
  Vue,
  Watch
} from 'vue-property-decorator';
import OrderDetails from '@/components/OrderDetails.vue';
import {namespace} from 'vuex-class';
import {
  Order,
  OrderFilters, OrderPriority,
  OrderStatus,
  Quote
} from '@/interfaces/order.interface';
import {
  User,
  UserGroup
} from '@/interfaces/user.interface';
import {shortDateFormat} from '@/helpers/helpers';
import PermissionsService from '../services/permissions.service';
import {VuetifyPaginationInterface} from '@/interfaces/vuetify-pagination.interface';

const ordersModule = namespace('orders');
const usersModule = namespace('users');

const AUTO_UPDATE_INTERVAL = 10000;
@Component({
  components: {OrderDetails}
})
export default class OrderTable extends Vue {
  @Prop({default: ''}) expandedOrderUuid!: string;
  @ordersModule.State orderFilters!: OrderFilters;
  @ordersModule.State statuses!: OrderStatus[];
  @ordersModule.Action deleteWithConfirmation: any;
  @ordersModule.Action rankUp: any;
  @ordersModule.Action rankDown: any;
  @ordersModule.Action update!: any;
  @ordersModule.Action fetchOrders: any;
  @ordersModule.Action setPagination: any;
  @usersModule.Getter currentUser!: User;
  @usersModule.State groups!: UserGroup[];

  autoUpdateInterval: number;
  pagination: VuetifyPaginationInterface = this.$store.state.orders.pagination;
  loading: boolean = false;

  @Watch('pagination', {immediate: true, deep: true})
  async paginationWatcher() {
    this.loading = true;
    this.setPagination({pagination: this.pagination});
    await this.fetchOrders();
    this.loading = false;
  }

  get orders(): Order[] {
    return this.$store.state.orders.orders;
  }

  get totalOrders(): number {
    return this.$store.state.orders.totalItems;
  }

  get totalHandlingTime(): string {
    const handlingTimeTotal = this.orders.reduce((a: Number, b: Order) => Number(a) + (Number(b.handlingTime) || 0), 0);
    return this.getHandlingTime(String(handlingTimeTotal));
  }

  mounted() {
    this.autoUpdateInterval = setInterval(this.fetchOrders, AUTO_UPDATE_INTERVAL);
  }

  beforeDestroy() {
    if (this.autoUpdateInterval) clearInterval(this.autoUpdateInterval);
  }

  private expandOrderBasedOnRoute() {
    if (!this.$refs.dataTable) return;
    if (this.expandedOrderUuid) {
      // @ts-ignore
      // noinspection TypeScriptUnresolvedVariable
      this.$set(this.$refs.dataTable.expanded, this.expandedOrderUuid, true);
    } else {
      this.orders.forEach((o: Order) => {
        // @ts-ignore
        // noinspection TypeScriptUnresolvedVariable
        this.$set(this.$refs.dataTable.expanded, o.uuid, false);
      });
    }
  }

  goToOrder(props: any): void {
    const order: Order = props.item;
    if (this.canExpandRow(order)) {
      this.$router.push(`/orders/${props.item.uuid}`);
    }
  }

  @Watch('$route', {immediate: true, deep: true})
  onUrlChange() {
    this.expandOrderBasedOnRoute();
  }

  get shortDateFormat(): string {
    return shortDateFormat;
  }

  // TODO: Unused getter?
  get statusFilter(): OrderStatus[] {
    return this.orderFilters.status || [];
  }

  get paginationItems(): any[] {
    return [50, 500, 1500];
  }

  get headers(): any[] {
    return [
      {sortable: false, text: 'Job', value: 'jobNumber'},
      {sortable: false, text: 'Order number', value: 'orderNumber'},
      {sortable: false, text: 'Sender', value: 'createdBy.firstName'},
      {text: 'Sender last name', value: 'createdBy.lastName', class: 'hidden'},
      {sortable: false, text: 'From → To', value: 'shipper.country'},
      {text: 'To', value: 'consignee.country', class: 'hidden'},
      {sortable: false, text: 'Status', value: 'status.name'},
      {sortable: false, text: 'Logistics', value: 'logistics.firstName'},
      {text: 'Logistics last name', value: 'logistics.lastName', class: 'hidden'},
      {sortable: false, text: 'Forwarder', value: 'forwarderCompanyName'},
      {sortable: false, text: 'Handling time', value: 'handlingTime'},
      {sortable: false, text: 'Total handling time: ' + this.totalHandlingTime, value: ''},
      {text: 'ETA', value: 'eta', class: 'hidden'},
      {text: 'Customs', value: 'customs', class: 'hidden'},
      {text: 'Priority', value: 'priority.name', class: 'hidden'},
      {text: 'Transport mode', value: 'transportMode', class: 'hidden'},
      {text: 'Consignee', value: 'consignee.name', class: 'hidden'},
      {text: 'Shipper', value: 'shipper.name', class: 'hidden'},
      {text: 'Date', value: 'createdAt', class: 'hidden'}
    ];
  }

  // TODO: Unused method?
  // getTransportIcon(type: string): string {
  //   switch (type) {
  //     case 'road':
  //       return 'local_shipping';
  //     case 'air':
  //       return 'airplanemode_active';
  //     case 'sea':
  //       return 'directions_boat';
  //     default:
  //       return '';
  //   }
  // }

  getTransportIconColor(type: string): string {
    switch (type && type.toLowerCase()) {
      case 'road':
        return 'orange';
      case 'air':
        return 'grey';
      case 'sea':
        return 'blue';
      default:
        return 'green';
    }
  }

  editOrder(order: Order): void {
    this.$router.push(`/orders/${order.uuid}/edit/`);
  }

  deleteOrder(order: Order): void {
    this.deleteWithConfirmation({order});
  }

  canAcceptOrder(props: { item: Order, index: number }) {
    if (!props.item.priority || !props.item.status) return false;
    if (props.item.priority.name === 'AOG' && props.item.status.name === 'Pending' && this.canUserAcceptOrders()) return true;
    if (!this.isFirstPendingOrder(props.item, props.index)) return false;
    if (!props.item.status || props.item.status.name === 'Accepted') return false;
    if (!this.canUserAcceptOrders()) return false;
    return true;
  }

  canUserAcceptOrders(): boolean {
    if (this.currentUser.roleName) {
      return ['admin_a', 'admin_b'].indexOf(this.currentUser.roleName) > -1;
    }
    return false;
  }

  acceptOrder(order: Order): void {
    if (order.status && order.status.name !== 'Accepted') {
      order.status = this.statuses.find((s: OrderStatus) => s.name === 'Accepted');
      this.update({order});
    }
  }

  isFirstPendingOrder(order: Order, index: number): boolean {
    if (order.status && order.status.name !== 'Pending') return false;
    for (let i = index + 1; i < this.orders.length; i++) {
      const o: Order = this.orders[i];
      if (o.status && o.status.name === 'Pending') return false;
    }
    return true;
  }

  getForwarderName(order: Order) {
    const selectedQuote = order.quotes && order.quotes.find((q: Quote) => q.selected!);
    if (selectedQuote) {
      return selectedQuote.forwarderCompanyName;
    } else {
      return order.forwarderCompanyName;
    }
  }

  getEta(order: Order) {
    const selectedQuote = order.quotes && order.quotes.find(q => q.selected!);
    if (selectedQuote) {
      return selectedQuote.eta;
    } else {
      return order.eta;
    }
  }

  getHandlingTime(timeString: string) {
    const totalHours = parseFloat(timeString);
    const hoursPerDay = 24;
    const minutesPerHour = 60;

    const days = Math.floor(totalHours / hoursPerDay);
    const fullDaysInHours = days * hoursPerDay;
    const remainingHoursAfterFullDays = totalHours - fullDaysInHours;
    const remainingHours = Math.floor(remainingHoursAfterFullDays);
    const remainingMinutes = Math.round((remainingHoursAfterFullDays - remainingHours) * minutesPerHour);

    const finalDays = remainingHours === hoursPerDay ? days + 1 : days;
    const finalHours = remainingHours === hoursPerDay ? 0 : remainingHours;

    const dayHourStr = finalDays > 0 ? `${finalDays} d${finalHours > 0 ? ` ${finalHours} h` : ''}` : '';
    const hourMinuteStr = totalHours < hoursPerDay ? `${remainingHours > 0 ? `${remainingHours} h ` : ''}${remainingMinutes} min` : '';

    return totalHours >= hoursPerDay ? dayHourStr : hourMinuteStr;
  }


  get canEditOrders(): boolean {
    return PermissionsService.can('orders', 'update');
  }

  get canDeleteOrders(): boolean {
    return PermissionsService.can('orders', 'delete');
  }

  async moveUp(order: Order): Promise<any> {
    await this.rankDown({orderUuid: order.uuid!});
  }

  async moveDown(order: Order): Promise<any> {
    await this.rankUp({orderUuid: order.uuid!});
  }

  isUpArrowVisible(props: { item: Order, index: number }): boolean {
    if (!props.item.status) return false;
    const previousOrder = this.orders[props.index - 1];
    if (!previousOrder) return false;
    return props.index !== 0;
  }

  isDownArrowVisible(props: { item: Order, index: number }): boolean {
    if (!props.item.status) return false;
    const nextOrder = this.orders[props.index + 1];
    if (!nextOrder) return false;
    return props.index !== this.orders.length - 1;
  }

  canExpandRow(order: Order): boolean {
    if (this.currentUser) {
      //@ts-ignore
      return this.currentUser.groupUuid === order.createdBy.groupUuid || ['admin_a', 'admin_b', 'admin_c', 'user_a'].indexOf(this.currentUser.roleName) > -1;
    }
    return false;
  }

  canEditRow(order: Order): boolean {
    if (order.status && order.status.name) {
      return ['Cancelled', 'Completed'].indexOf(order.status.name) <= -1;

    }
    return false;
  }

  getRowClass(order: Order): string {
    return this.canExpandRow(order) ? 'clickable-row' : 'foreign-row';
  }

  isUnseen(order: Order): boolean {
    if (order && order.unseen) {
      return order.unseen.creator === this.currentUser.uuid
          || order.unseen.logistics === this.currentUser.uuid
    } else {
      return false;
    }
  }

  createdByCell(order: Order): string {
    if (order.createdBy) {
      const groupUuid = order.createdBy.groupUuid;
      const group = this.groups && this.groups.find(g => g.uuid === groupUuid) || {};
      return `${order.createdBy.firstName} ${order.createdBy.lastName} (${group.label})`;
    }
    return '';
  }

  get canReorder(): boolean {
    return this.currentUser.roleName === 'admin_a';
  }

}
